import React, { useState , useEffect}  from 'react';
import { useStateContext } from '../../contexts/ContextProvider';
import {useSalidasMutations} from '../../hooks';

import { fetchUser } from '../../utils/fetchUser';
import { Toaster,toast } from 'react-hot-toast';
import {getDropoffs} from "../../services/dropoff";
import {getRecolectoresRut} from "../../services/Recolectores";
import { SearchRecolector } from '../../components';

import ButtonToolBar from '../../components/ButtonToolBar';
import {formatDate} from '../../formatters/date';


const initialState = {
empresa: null,
numeroSalida: 0,
idDropoff: null,
idRecolector: '',
rut: '',
nombreRecolector:'',
cantidad: '',
descripcion:'',
fechaCreacion: Date.now()
};

const RegistroSalidas = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [planesData, setPlanesData] = useState([]);
  const { addSalida } = useSalidasMutations();

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttonsTool, setButtonsTool] = useState([
    { name: 'cancel', label: 'Cancelar', disabled: false },
    { name: 'save', label: 'Guardar', disabled: false },
  ]);

  const userInfo = fetchUser();

  useEffect(() => {
    const fetchData = async () => {
      const miCliente = await getRecolectoresRut(formData.rut);
      //console.log("LEI EL CLIENTE " + JSON.stringify(miCliente));
      setFormData((prev) => ({
        ...prev,
        nombreRecolector: miCliente[0].nombreRecolector, idRecolector: miCliente[0]._id,
      }));
    };
    if(formData.rut !== '') {
      // Lee datos cliente usando API por rut
      fetchData();
    }
  }, [formData.rut]);

  useEffect(()=>{
    const fetchData = async () => {
      const misPlanes = await getDropoffs();
      setPlanesData(misPlanes);
    };
    fetchData();
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  const handleSubmit = async () =>{
    
    try {
      
          const datosSolicitud = {
            empresa: userInfo.empresa,
            numeroSalida: 0,
            idDropoff: formData.idDropoff,
            idRecolector: formData.idRecolector,
            cantidad: formData.cantidad,
            descripcion: formData.descripcion,
            fechaCreacion: Date.now(),
          };
          
         const daRecp = await addSalida.mutateAsync( datosSolicitud );
   
         setFormData((prev) => ({
          ...prev,
          numeroSalida: daRecp.numeroSalida,
        }));

         toast.success("Salida de residuos realizada con N° " + daRecp.numeroSalida );
         setFormData(initialState);

    } catch (error) {
      console.log("Problemas al momento de Registrar Cliente y Plan, contacte a soporte" + error);
      toast.error("Problemas al momento de Registrar Cliente y Plan, contacte a soporte");
    }
  }
 
  const handleCancelar = async () =>{  
      setFormData(initialState);
  }

  const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'save') {
      handleSubmit();
    } else if (buttonName === 'cancel') {
      handleCancelar();
    }
  };

  return (
    <form  onSubmit={handleSubmit} >
        <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">


        <div className="container mx-auto p-2 md:p-2">

        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-green-800 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                Registro Salidas
              </p>
            </div>

        </div>

     <div className="bg-gray-200 p-6 rounded-lg shadow-lg mt-2">
        <div className="grid grid-cols-2 md:grid-cols-7 gap-4" >

            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Drop Off</label>
                <select className={inputClass} name="idDropoff" 
                value= {formData.idDropoff} 
                required
                onChange={handleChange}>
                  <option value=""></option>
                  {planesData?.map((item, index) => (
                    <option  key={item._id} value={item._id}>{item.nombrePunto}</option>
                  ))}  
                  </select> 
            </div> 

            <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Rut Recolector</label>
                  <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="rut"
                  value= {formData.rut}
                  onChange={handleChange}
                  />
                </div> 
              <div className="flex flex-col">
              <SearchRecolector estado='Activo'
              onValorSeleccionadoChange={(cliSeleccionado) => {   
                if (!cliSeleccionado) return;
                setFormData((prev) => ({
                  ...prev,
                  rut: cliSeleccionado.rut,
                  nombreRecolector: cliSeleccionado.nombreRecolector,
                  idRecolector: cliSeleccionado.idRecolector,
                }));

              }}
              />
              </div>


                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Nombre</label>
                    <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="nombreRecolector"
                      value= {formData.nombreRecolector}
                      onChange={handleChange}
                      disabled 
                    />
                  </div> 
                </div>
            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Salida</label>            
                <input
                className={inputClass}
                type="text"
                placeholder=""
                name="numeroSalida"
                value= {formData.numeroSalida}
                disabled
              />
            </div>
            <div className="col-span-2">
              <div className="flex flex-col items-start">      
                <label className="text-xs font-semibold mb-1">Fecha</label>            
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="fechaCreacion"
                  value= {formatDate(formData.fechaCreacion)}
                  disabled
                />
              </div>
            </div>


            </div>    
        </div>   

          <div className="mt-5 space-y-4">
              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4" >
                    <div className="col-span-4">
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Observación</label>
                          <input
                              className={inputClass}
                              type="text"
                              placeholder=""
                              name="descripcion"
                              value= {formData.descripcion}
                              onChange={handleChange}
                            />
                      </div>  
                    </div> 
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Cantidad</label>
                      <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="cantidad"
                        value= {formData.cantidad}
                        onChange={handleChange}
                      />
                  </div> 
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                  <div className="flex flex-col mt-4">
                    <ButtonToolBar buttons={buttonsTool} onButtonClick={handleButtonToolBarClick} />
                  </div>
                </div>

              </div>   
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />         
          </div>

        </div>
      </div>
    </form>
  );
};

export default RegistroSalidas;

